import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { RoomiDialog, RoomiButton } from 'roomi/material';
import { DialogContent, withStyles } from '@material-ui/core';
import { FormattedMessage, injectIntl } from 'react-intl';
import messages from './mover-modal.text';
import moverModalStyles from './mover-modal.styles';
import image from '../../assets/furniture.png';

@injectIntl
@withStyles(moverModalStyles)
class MoverModal extends PureComponent {
  static propTypes = {
    onClose: PropTypes.func.isRequired
  };

  closeModal = () => this.props.onClose('mover');

  render() {
    const { intl: { formatMessage }, classes } = this.props;
    return (
      <RoomiDialog
        open
        title={formatMessage(messages.title)}
      >
        <DialogContent className={classes.root}>
          <FormattedMessage {...messages.sub}>
            {t => <div className={classes.sub}>{t}</div>}
          </FormattedMessage>
          <div className={classes.image}>
            <img src={image} alt="Mover"/>
          </div>
          <FormattedMessage {...messages.text}>
            {t => <div className={classes.text}>{t}</div>}
          </FormattedMessage>
          <div className={classes.text2}>
            <FormattedMessage {...messages.text2}/>
            &nbsp;
            <FormattedMessage {...messages.text3}>
              {t => <span className={classes.text3}>{t}</span>}
            </FormattedMessage>
          </div>
          <RoomiButton
            className={classes.button}
            small
            primary
            onClick={this.closeModal}
            label={formatMessage(messages.close)}
          />
        </DialogContent>
      </RoomiDialog>
    );
  }
}

export default MoverModal;
